<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-row no-gutters align="center" class="pa-5 pt-0 pb-8 mb-8">
                <v-col cols="auto">
                    <v-img
                        src="@/assets/star_like.png"
                        width="60"
                        height="60"
                    ></v-img>
                </v-col>

                <v-col cols="8" class="pl-5">
                    <h4 v-text="translations.title[lang]"></h4>
                    <div
                        style="font-size: 0.875rem"
                        class="font-weight-medium mt-1"
                        v-text="translations.info[lang]"
                    ></div>
                </v-col>
            </v-row>

            <v-data-table
                :headers="headers"
                :items="stores"
                :footer-props="{
                    itemsPerPageOptions: [12],
                    showCurrentPage: true,
                    pageText: `${page * 12 - 11}-${
                        page * 12 <= serverItemsLength
                            ? page * 12
                            : serverItemsLength
                    } ${
                        translations.paginationText[lang]
                    } ${serverItemsLength}`,
                }"
                :server-items-length="serverItemsLength"
                :page.sync="page"
                :loading="loading"
                class="b-outlined mt-8"
            >
                <template v-slot:item.name="{ item }">
                    {{ item.name }}
                    <v-icon
                        v-text="icons.mdiLaunch"
                        style="cursor: pointer"
                    ></v-icon>
                </template>

                <template v-slot:item.purchases_goal>
                    <v-btn
                        color="secondary"
                        class="text-capitalize px-5"
                        depressed
                        v-text="translations.edit[lang]"
                        @click="purchasedCouponsDialog = true"
                    ></v-btn>
                </template>

                <template v-slot:item.code_coupon>
                    <v-btn
                        color="secondary"
                        class="text-capitalize px-5"
                        depressed
                        v-text="translations.edit[lang]"
                        @click="codeCouponsDialog = true"
                    ></v-btn>
                </template>

                <template v-slot:item.product_coupon>
                    <v-btn
                        color="secondary"
                        class="text-capitalize px-5"
                        depressed
                        v-text="translations.edit[lang]"
                        @click="productCouponsDialog = true"
                    ></v-btn>
                </template>

                <template v-slot:item.discount_coupon>
                    <v-btn
                        color="secondary"
                        class="text-capitalize px-5"
                        depressed
                        v-text="translations.edit[lang]"
                        @click="discountCouponsDialog = true"
                    ></v-btn>
                </template>
            </v-data-table>

            <v-dialog v-model="purchasedCouponsDialog" max-width="500">
                <b-card
                    title="Purchased Coupons"
                    @cancel="purchasedCouponsDialog = false"
                    :submit-text="{
                        el: 'Προσθήκη',
                        en: 'Save',
                        it: 'Aggiungi',
                    }"
                    :cancel-text="{
                        el: 'Κλείσιμο',
                        en: 'Cancel',
                        it: 'Chiudi',
                    }"
                >
                    <PurchasedCouponsForm />
                </b-card>
            </v-dialog>
            <v-dialog v-model="codeCouponsDialog" max-width="500">
                <CouponWithCodeForm @cancel="codeCouponsDialog = false" />
            </v-dialog>
            <v-dialog v-model="productCouponsDialog" max-width="500">
                <CouponOnProductForm @cancel="productCouponsDialog = false" />
            </v-dialog>
            <v-dialog v-model="discountCouponsDialog" max-width="500">
                <CouponWithDiscountForm
                    @cancel="discountCouponsDialog = false"
                />
            </v-dialog>
        </v-sheet>
    </v-container>
</template>

<script>
import { mdiLaunch } from "@mdi/js";
import CouponOnProductForm from "@/components/storePanel/coupons/CouponOnProductForm.vue";
import CouponWithDiscountForm from "@/components/storePanel/coupons/CouponWithDiscountForm.vue";
import CouponWithCodeForm from "@/components/storePanel/coupons/CouponWithCodeForm.vue";
import PurchasedCouponsForm from "@/components/storePanel/coupons/PurchasedCouponsForm.vue";
import translations from "@/utils/translations/loyaltyPanel/storeCoupons";
import { mapActions, mapState } from "vuex";

export default {
    name: "StoreCoupons",

    mixins: [translations],

    components: {
        CouponOnProductForm,
        CouponWithDiscountForm,
        CouponWithCodeForm,
        PurchasedCouponsForm,
    },

    data() {
        return {
            icons: { mdiLaunch },
            page: +this.$route.query.page,
            attributionTypes: [
                {
                    name: "Per Amount",
                    value: 1,
                },
                {
                    name: "Per Product",
                    value: 2,
                },
            ],
            productCouponsDialog: false,
            discountCouponsDialog: false,
            codeCouponsDialog: false,
            purchasedCouponsDialog: false,
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel/stores/storesTab", ["stores"]),

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                {
                    text: this.translations.name[this.lang],
                    value: "name",
                },
                {
                    text: this.translations.purchasesGoal[this.lang],
                    value: "purchases_goal",
                    width: 200,
                },
                {
                    text: this.translations.codeCoupon[this.lang],
                    value: "code_coupon",
                },
                {
                    text: this.translations.productCoupon[this.lang],
                    value: "product_coupon",
                },
                {
                    text: this.translations.discountCoupon[this.lang],
                    value: "discount_coupon",
                },
            ];
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getItems(this.query);
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },

    mounted() {
        this.getItems(this.query);
    },

    methods: {
        ...mapActions("loyaltyPanel/stores/storesTab", ["getItems"]),
    },
};
</script>
